import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Ming Yin Kiosk App translations
const resources = {
  'zh-TW': {
    translation: {
      // App
      'app.title': '名彥專業養生理療中心',
      'app.subtitle': '會員登記',
      'app.welcome': '歡迎光臨',

      // Steps
      'step.personal': '個人資料',
      'step.contact': '聯絡資料',
      'step.bodyMetrics': '身體數據',
      'step.bodyMetrics.description': '請填寫您的身高和體重（選填）',
      'step.chiefComplaint': '主要訴求',
      'step.chiefComplaint.description': '請告訴我們您今天來訪的主要原因',
      'step.healthConditions': '健康狀況',
      'step.painAssessment': '疼痛評估',
      'step.symptomChecklist': '症狀檢查',
      'step.symptoms': '症狀檢查',
      'step.symptoms.description': '請選擇您目前出現的症狀（選填）',
      'step.lifestyle': '生活習慣及療法偏好',
      'step.emergency': '緊急聯絡人',
      'step.emergency.description': '請提供緊急聯絡人資料（選填）',
      'step.review': '資料確認',
      'step.review.description': '請確認以下資料是否正確',
      'step.review.continueToConsent': '確認無誤後，請點擊「下一步」繼續',
      'step.consent': '同意條款',
      'step.signature': '簽名確認',
      'step.complete': '完成登記',

      // Common
      'common.yes': '是',
      'common.no': '否',
      'common.select': '請選擇',
      'common.notProvided': '未填寫',
      'common.pleaseSpecify': '請說明',

      // Personal Info
      'field.firstName': '名字',
      'field.lastName': '姓氏',
      'field.email': '電郵地址',
      'field.email.optional': '選填',
      'field.phone': '電話號碼',
      'field.dateOfBirth': '出生日期',
      'field.gender': '性別',
      'field.gender.male': '男',
      'field.gender.female': '女',
      'field.gender.other': '其他',
      'field.hkId': '香港身份證（首5位）',
      'field.hkId.helper': '格式：A1234 或 AB123',
      'field.occupation': '職業',
      'field.year': '年',
      'field.month': '月',

      // Month names
      'month.1': '1月',
      'month.2': '2月',
      'month.3': '3月',
      'month.4': '4月',
      'month.5': '5月',
      'month.6': '6月',
      'month.7': '7月',
      'month.8': '8月',
      'month.9': '9月',
      'month.10': '10月',
      'month.11': '11月',
      'month.12': '12月',

      // Body Metrics
      'field.height': '身高',
      'field.weight': '體重',
      'unit.meters': '米',
      'unit.feet': '呎',
      'unit.kg': '公斤',
      'unit.lbs': '磅',

      // Chief Complaint
      'field.symptomOnset': '症狀/疼痛開始時間',
      'field.chiefComplaint': '主要求診原因',
      'field.chiefComplaint.placeholder': '請描述您今天來訪的主要原因',
      'field.mainProblem': '最希望解決的問題',
      'field.mainProblem.placeholder': '請描述您最想解決的問題是什麼',

      // Medical Conditions
      'conditions.title': '健康狀況（如有請勾選）',
      'conditions.highBloodPressure': '高血壓',
      'conditions.diabetes': '糖尿病',
      'conditions.heartDisease': '心臟病',
      'conditions.thyroidDisease': '甲狀腺疾病',
      'conditions.liverGallbladderStomach': '肝/膽/胃問題',
      'conditions.cancerTumorSurgery': '癌症/腫瘤/手術史',
      'conditions.breastConditions': '乳房手術/疾病',
      'conditions.allergies': '過敏體質',
      'conditions.insomnia': '失眠',
      'conditions.obesity': '肥胖/高體脂',
      'conditions.thalassemia': '地中海貧血',
      'conditions.pregnancyPostpartumMenstrual': '懷孕/產後/經期問題',
      'conditions.anxietyEmotional': '焦慮/情緒問題',
      'conditions.kidneyProblems': '腎臟問題',
      'conditions.reproductivePelvic': '生殖/骨盆疾病',

      // Medical History
      'medicalHistory.title': '病史',
      'medicalHistory.surgery': '曾否接受手術',
      'medicalHistory.surgery.placeholder': '請說明手術類型及時間',
      'medicalHistory.injury': '曾否受傷',
      'medicalHistory.injury.placeholder': '請說明受傷情況',
      'medicalHistory.accident': '曾否發生意外',
      'medicalHistory.accident.placeholder': '請說明意外情況',
      'medicalHistory.implant': '體內是否有植入物/異物',
      'medicalHistory.implant.placeholder': '請說明植入物類型',

      // Imaging History
      'imaging.title': '檢查及治療記錄',
      'imaging.xray': 'X光',
      'imaging.ctScan': 'CT掃描',
      'imaging.mri': 'MRI',
      'imaging.electrotherapy': '電療',
      'imaging.magneticTherapy': '磁療',
      'imaging.previousTreatment': '曾接受的治療',
      'imaging.previousTreatment.placeholder': '請描述您曾接受過的治療',
      'imaging.effectiveness': '治療效果',
      'imaging.effectiveness.placeholder': '請描述之前治療的效果如何',

      // Pain Location
      'pain.location.title': '疼痛部位',
      'pain.location.neck': '頸部',
      'pain.location.shoulder': '肩膀',
      'pain.location.upperBack': '上背',
      'pain.location.lowerBack': '下背',
      'pain.location.lumbar': '腰部',
      'pain.location.hips': '髖部',
      'pain.location.knees': '膝蓋',
      'pain.location.armsElbowsWrists': '手臂/肘/腕',
      'pain.location.legsSciatica': '腿部/坐骨神經',
      'pain.location.other': '其他',
      'pain.location.otherDetails': '其他部位說明',
      'pain.location.otherDetails.placeholder': '請說明其他疼痛部位',
      'pain.side.left': '左',
      'pain.side.right': '右',
      'pain.side.both': '雙側',

      // Pain Characteristics
      'pain.characteristics.title': '疼痛特徵',
      'pain.type.title': '疼痛類型',
      'pain.type.dull': '鈍痛',
      'pain.type.sharp': '刺痛',
      'pain.type.radiating': '放射痛',
      'pain.type.numbness': '麻木',
      'pain.type.tingling': '刺麻',
      'pain.trigger.title': '疼痛誘因',
      'pain.trigger.movement': '活動時',
      'pain.trigger.lifting': '提重物時',
      'pain.trigger.prolongedStanding': '久站時',
      'pain.severity': '疼痛程度',
      'pain.severity.none': '無痛',
      'pain.severity.worst': '極痛',
      'pain.frequency.title': '疼痛頻率',
      'pain.frequency.constant': '持續',
      'pain.frequency.intermittent': '間歇',

      // Symptoms by body area
      'symptoms.neck.title': '頸部相關症狀',
      'symptoms.neck.dizzinessHeadaches': '頭暈/頭痛',
      'symptoms.neck.numbnessUpperLimbs': '上肢麻木',
      'symptoms.neck.eyeStrainBlurredVision': '眼睛疲勞/視力模糊',
      'symptoms.neck.poorBalanceWalking': '步行平衡差',
      'symptoms.neck.tinnitusHearingReduction': '耳鳴/聽力下降',

      'symptoms.shoulder.title': '肩膀相關症狀',
      'symptoms.shoulder.limitedBackwardMovement': '向後活動受限',
      'symptoms.shoulder.painLiftingArms': '舉手疼痛',
      'symptoms.shoulder.tendernessStiffness': '壓痛/僵硬',

      'symptoms.spine.title': '脊椎/姿勢相關症狀',
      'symptoms.spine.chestTightness': '胸悶',
      'symptoms.spine.legLengthDifference': '雙腿長度不一',
      'symptoms.spine.scoliosisAwareness': '脊柱側彎意識',

      'symptoms.lumbar.title': '腰部相關症狀',
      'symptoms.lumbar.radiatingLegPain': '腿部放射痛',
      'symptoms.lumbar.sciatica': '坐骨神經痛',
      'symptoms.lumbar.difficultyBendingStanding': '彎腰/久站困難',
      'symptoms.lumbar.herniationSymptoms': '椎間盤突出症狀',
      'symptoms.lumbar.backSpasms': '背部痙攣',

      'symptoms.knee.title': '膝蓋相關症狀',
      'symptoms.knee.clickingSounds': '響聲',
      'symptoms.knee.difficultyClimbingStairs': '上下樓梯困難',
      'symptoms.knee.swelling': '腫脹',
      'symptoms.knee.weatherSensitivePain': '天氣敏感痛',

      'symptoms.joints.title': '關節相關症狀',
      'symptoms.joints.stiffness': '僵硬',
      'symptoms.joints.inabilityStraightenLimbs': '無法伸直四肢',
      'symptoms.joints.fearOfCold': '怕冷',

      'symptoms.other.title': '其他症狀',
      'symptoms.other.fatigue': '疲勞',
      'symptoms.other.weakness': '無力',
      'symptoms.other.sleepDisturbance': '睡眠障礙',

      // Lifestyle
      'lifestyle.habits.title': '生活習慣',
      'lifestyle.smoking': '吸煙',
      'lifestyle.alcohol': '飲酒',
      'lifestyle.workPosture.title': '工作姿勢',
      'lifestyle.workPosture.deskWork': '久坐工作',
      'lifestyle.workPosture.lifting': '搬重物',
      'lifestyle.workPosture.repetitiveTasks': '重複性工作',
      'lifestyle.prolongedSitting': '長時間坐著',
      'lifestyle.prolongedStanding': '長時間站立',
      'lifestyle.stressLevel': '壓力程度',
      'lifestyle.stressLevel.low': '低',
      'lifestyle.stressLevel.high': '高',
      'lifestyle.sleepQuality': '睡眠質素',
      'lifestyle.sleepQuality.poor': '差',
      'lifestyle.sleepQuality.fair': '一般',
      'lifestyle.sleepQuality.good': '好',
      'lifestyle.sleepQuality.excellent': '很好',
      'lifestyle.activityLevel': '活動量',
      'lifestyle.activityLevel.sedentary': '久坐不動',
      'lifestyle.activityLevel.light': '輕度',
      'lifestyle.activityLevel.moderate': '中度',
      'lifestyle.activityLevel.active': '活躍',

      // Women's Health
      'womens.title': '女性健康',
      'womens.pregnancy': '目前懷孕',
      'womens.postpartum': '產後期間',
      'womens.menstrualRegularity': '月經規律',
      'womens.menstrualRegularity.regular': '規律',
      'womens.menstrualRegularity.irregular': '不規律',
      'womens.menstrualRegularity.none': '無月經',
      'womens.menstrualPain': '經期疼痛',
      'womens.gynecologicalConditions': '婦科疾病',
      'womens.gynecologicalConditions.placeholder': '如有婦科疾病請說明',

      // Medications & Allergies
      'medications.title': '藥物及過敏',
      'medications.current': '目前服用藥物',
      'medications.current.placeholder': '請列出您目前服用的藥物',
      'medications.supplements': '保健品/中藥',
      'medications.supplements.placeholder': '請列出您正在服用的保健品或中藥',
      'allergies.medicine': '藥物過敏',
      'allergies.medicine.placeholder': '請列出您對哪些藥物過敏',
      'allergies.food': '食物過敏',
      'allergies.food.placeholder': '請列出您對哪些食物過敏',
      'allergies.environmental': '環境過敏',
      'allergies.environmental.placeholder': '如花粉、塵蟎等',

      // Treatment Preferences
      'treatment.title': '療法偏好',
      'treatment.expectedOutcomes': '期望治療效果',
      'treatment.expectedOutcomes.placeholder': '請描述您期望的治療效果',
      'treatment.preferredTherapies': '偏好的療法',
      'treatment.therapy.massage': '按摩',
      'treatment.therapy.acupuncture': '針灸',
      'treatment.therapy.cupping': '拔罐',
      'treatment.therapy.manualTherapy': '手法治療',
      'treatment.therapy.exerciseRehab': '運動復健',
      'treatment.therapy.physicalTherapy': '物理治療',
      'treatment.therapy.heatTherapy': '熱療',
      'treatment.therapy.electroTherapy': '電療',
      'treatment.refusedTreatments': '拒絕或害怕的療法',
      'treatment.refusedTreatments.placeholder': '如有請說明',

      // Emergency Contact
      'field.emergency.name': '緊急聯絡人姓名',
      'field.emergency.phone': '緊急聯絡人電話',
      'field.emergency.relationship': '關係',

      // Referral
      'field.referralSource': '如何得知我們',
      'field.referralSource.walk_in': '自行到訪',
      'field.referralSource.referral': '朋友推薦',
      'field.referralSource.online': '網上搜尋',
      'field.referralSource.advertisement': '廣告',
      'field.referralSource.social_media': '社交媒體',
      'field.referralSource.other': '其他',
      'field.referredBy': '推薦人姓名',
      'field.referredByPhone': '推薦人電話號碼',

      // Consent
      'consent.terms': '服務條款',
      'consent.terms.text': '本人同意接受名彥專業養生理療中心的服務條款。',
      'consent.privacy': '私隱政策',
      'consent.privacy.text': '本人同意名彥專業養生理療中心按照私隱政策收集及使用本人的個人資料。',
      'consent.health': '健康免責聲明',
      'consent.health.text': '本人確認身體狀況適合接受養生理療服務，如有任何健康問題會主動告知職員。',
      'consent.marketing': '市場推廣（選填）',
      'consent.marketing.text': '本人同意接收名彥專業養生理療中心的推廣資訊及優惠通知。',

      // Signature
      'signature.instruction': '請在下方簽名確認以上資料',
      'signature.clear': '清除',
      'signature.required': '請先簽名',
      'signature.skipForStaff': '職員代為登記，稍後補簽',
      'signature.skipInfo': '會員稍後可在中心補簽署。職員將在 CMS 系統中收集簽名。',

      // Buttons
      'button.next': '下一步',
      'button.back': '返回',
      'button.submit': '提交',
      'button.skip': '跳過此步驟',
      'button.startOver': '重新開始',
      'button.changeLanguage': '語言',
      'button.closeWindow': '關閉視窗',

      // Validation
      'validation.required': '此欄位為必填',
      'validation.email': '請輸入有效的電郵地址',
      'validation.phone': '請輸入有效的電話號碼',
      'validation.hkIdFormat': '格式不正確（例：A1234）',

      // Success
      'success.title': '登記成功！',
      'success.message': '感謝您的登記。',
      'success.memberId': '您的會員編號',
      'success.passToStaff': '請將裝置交還給職員',
      'success.passToStaffSubtext': '職員將為您完成登記程序',

      // Errors
      'error.title': '發生錯誤',
      'error.tryAgain': '請重試',
      'error.duplicatePhone': '此電話號碼已被註冊',
      'error.duplicateEmail': '此電郵地址已被註冊',
      'error.invalidEmail': '請提供有效的電郵地址',
      'error.sessionExpired': '會話已過期。請向職員索取新的登記連結。',
      'error.serverError': '伺服器錯誤。請稍後再試。',
      'error.networkError': '無法連接。請檢查您的網絡連接。',

      // Duplicate member dialog
      'duplicate.title': '會員已存在',
      'duplicate.message': '此電話號碼已有會員註冊。',
      'duplicate.viewInfo': '查看會員資料',
      'duplicate.changePhone': '使用其他電話',
      'duplicate.memberInfo': '現有會員資料',
      'duplicate.contactStaff': '如需處理現有會員事宜，請聯繫職員協助。',
      'duplicate.name': '姓名',
      'duplicate.phone': '電話',
      'duplicate.email': '電郵',
      'duplicate.memberSince': '註冊日期',
      'duplicate.close': '關閉',

      // Accessibility
      'accessibility.fontSize': '字體大小',
      'accessibility.fontSize.normal': '正常',
      'accessibility.fontSize.large': '大',
      'accessibility.fontSize.xlarge': '特大',
      'accessibility.highContrast': '高對比',
      'accessibility.highContrast.on': '開啟高對比',
      'accessibility.highContrast.off': '關閉高對比',

      // Auth/Session
      'auth.sessionBy': '登入者',
      'auth.minutesRemaining': '剩餘 {{count}} 分鐘',
      'auth.sessionExpired': '會話已過期',
      'auth.sessionExpiredMessage': '您的登記會話已過期。請向職員索取新的登記連結。',
      'auth.invalidSession': '無效的會話',
      'auth.invalidSessionMessage': '登記連結無效或已過期。請向職員索取新的登記連結。',
      'auth.loading': '正在驗證會話...',
      'auth.sessionError': '會話錯誤',
      'auth.accessDenied': '拒絕訪問',
      'auth.noSession': '未找到有效的會話',
      'auth.instructionsError': '請關閉此窗口並從 CMS 控制台開啟新的登記會話。',
      'auth.closeWindow': '關閉窗口',
      'auth.expiringSoon': '會話即將過期！',
      'auth.verifying': '正在驗證會話...',
      'auth.connectionError': '連線錯誤',
      'auth.serverUnreachable': '無法連接伺服器',
      'auth.serverUnreachableMessage': '暫時無法連接登記系統伺服器。您的登記連結可能仍然有效，請稍後重試。',
      'auth.instructionsServerUnreachable': '請稍候片刻，然後按「重試」。如問題持續，請通知資訊部同事。',
      'auth.retry': '重試',
      'auth.unknownErrorMessage': '驗證會話時發生未預期的錯誤。',
    }
  },
  'en': {
    translation: {
      // App
      'app.title': 'Ming Yin Professional Health Center',
      'app.subtitle': 'Member Registration',
      'app.welcome': 'Welcome',

      // Steps
      'step.personal': 'Personal Info',
      'step.contact': 'Contact Info',
      'step.bodyMetrics': 'Body Metrics',
      'step.bodyMetrics.description': 'Please enter your height and weight (optional)',
      'step.chiefComplaint': 'Chief Complaint',
      'step.chiefComplaint.description': 'Please tell us the main reason for your visit today',
      'step.healthConditions': 'Health Conditions',
      'step.painAssessment': 'Pain Assessment',
      'step.symptomChecklist': 'Symptom Checklist',
      'step.symptoms': 'Symptom Checklist',
      'step.symptoms.description': 'Please select any symptoms you are currently experiencing (optional)',
      'step.lifestyle': 'Lifestyle & Treatment',
      'step.emergency': 'Emergency Contact',
      'step.emergency.description': 'Please provide emergency contact information (optional)',
      'step.review': 'Review Information',
      'step.review.description': 'Please verify the information below is correct',
      'step.review.continueToConsent': 'If everything looks correct, click "Next" to continue',
      'step.consent': 'Consent',
      'step.signature': 'Signature',
      'step.complete': 'Complete',

      // Common
      'common.yes': 'Yes',
      'common.no': 'No',
      'common.select': 'Please select',
      'common.notProvided': 'Not provided',
      'common.pleaseSpecify': 'Please specify',

      // Personal Info
      'field.firstName': 'First Name',
      'field.lastName': 'Last Name',
      'field.email': 'Email Address',
      'field.email.optional': 'Optional',
      'field.phone': 'Phone Number',
      'field.dateOfBirth': 'Date of Birth',
      'field.gender': 'Gender',
      'field.gender.male': 'Male',
      'field.gender.female': 'Female',
      'field.gender.other': 'Other',
      'field.hkId': 'HK ID (First 5 characters)',
      'field.hkId.helper': 'Format: A1234 or AB123',
      'field.occupation': 'Occupation',
      'field.year': 'Year',
      'field.month': 'Month',

      // Month names
      'month.1': 'January',
      'month.2': 'February',
      'month.3': 'March',
      'month.4': 'April',
      'month.5': 'May',
      'month.6': 'June',
      'month.7': 'July',
      'month.8': 'August',
      'month.9': 'September',
      'month.10': 'October',
      'month.11': 'November',
      'month.12': 'December',

      // Body Metrics
      'field.height': 'Height',
      'field.weight': 'Weight',
      'unit.meters': 'm',
      'unit.feet': 'ft',
      'unit.kg': 'kg',
      'unit.lbs': 'lbs',

      // Chief Complaint
      'field.symptomOnset': 'When did the symptom/pain begin?',
      'field.chiefComplaint': 'Primary reason for visit',
      'field.chiefComplaint.placeholder': 'Please describe the main reason for your visit today',
      'field.mainProblem': 'What problem do you most want to resolve?',
      'field.mainProblem.placeholder': 'Please describe what you most want to address',

      // Medical Conditions
      'conditions.title': 'Health Conditions (select if applicable)',
      'conditions.highBloodPressure': 'High blood pressure',
      'conditions.diabetes': 'Diabetes',
      'conditions.heartDisease': 'Heart disease',
      'conditions.thyroidDisease': 'Thyroid disease',
      'conditions.liverGallbladderStomach': 'Liver/gallbladder/stomach problems',
      'conditions.cancerTumorSurgery': 'Cancer/tumor/surgery history',
      'conditions.breastConditions': 'Breast surgery/conditions',
      'conditions.allergies': 'Allergies/sensitive constitution',
      'conditions.insomnia': 'Insomnia',
      'conditions.obesity': 'Obesity/high body fat',
      'conditions.thalassemia': 'Thalassemia',
      'conditions.pregnancyPostpartumMenstrual': 'Pregnancy/postpartum/menstrual issues',
      'conditions.anxietyEmotional': 'Anxiety/emotional issues',
      'conditions.kidneyProblems': 'Kidney problems',
      'conditions.reproductivePelvic': 'Reproductive/pelvic conditions',

      // Medical History
      'medicalHistory.title': 'Medical History',
      'medicalHistory.surgery': 'Past surgeries',
      'medicalHistory.surgery.placeholder': 'Please specify surgery type and date',
      'medicalHistory.injury': 'Past injuries',
      'medicalHistory.injury.placeholder': 'Please describe the injury',
      'medicalHistory.accident': 'Past accidents',
      'medicalHistory.accident.placeholder': 'Please describe the accident',
      'medicalHistory.implant': 'Implants or foreign objects',
      'medicalHistory.implant.placeholder': 'Please specify implant type',

      // Imaging History
      'imaging.title': 'Imaging & Treatment History',
      'imaging.xray': 'X-ray',
      'imaging.ctScan': 'CT scan',
      'imaging.mri': 'MRI',
      'imaging.electrotherapy': 'Electrotherapy',
      'imaging.magneticTherapy': 'Magnetic therapy',
      'imaging.previousTreatment': 'Previous treatments',
      'imaging.previousTreatment.placeholder': 'Please describe treatments you have tried',
      'imaging.effectiveness': 'Treatment effectiveness',
      'imaging.effectiveness.placeholder': 'Please describe how effective previous treatments were',

      // Pain Location
      'pain.location.title': 'Pain Location',
      'pain.location.neck': 'Neck',
      'pain.location.shoulder': 'Shoulder',
      'pain.location.upperBack': 'Upper back',
      'pain.location.lowerBack': 'Lower back',
      'pain.location.lumbar': 'Waist (lumbar)',
      'pain.location.hips': 'Hips',
      'pain.location.knees': 'Knees',
      'pain.location.armsElbowsWrists': 'Arms/Elbows/Wrists',
      'pain.location.legsSciatica': 'Legs/Sciatica',
      'pain.location.other': 'Other',
      'pain.location.otherDetails': 'Other location details',
      'pain.location.otherDetails.placeholder': 'Please specify other pain location',
      'pain.side.left': 'Left',
      'pain.side.right': 'Right',
      'pain.side.both': 'Both',

      // Pain Characteristics
      'pain.characteristics.title': 'Pain Characteristics',
      'pain.type.title': 'Pain Type',
      'pain.type.dull': 'Dull',
      'pain.type.sharp': 'Sharp',
      'pain.type.radiating': 'Radiating',
      'pain.type.numbness': 'Numbness',
      'pain.type.tingling': 'Tingling',
      'pain.trigger.title': 'Pain Triggers',
      'pain.trigger.movement': 'Movement',
      'pain.trigger.lifting': 'Lifting',
      'pain.trigger.prolongedStanding': 'Prolonged standing',
      'pain.severity': 'Pain Severity',
      'pain.severity.none': 'No pain',
      'pain.severity.worst': 'Worst pain',
      'pain.frequency.title': 'Pain Frequency',
      'pain.frequency.constant': 'Constant',
      'pain.frequency.intermittent': 'Intermittent',

      // Symptoms by body area
      'symptoms.neck.title': 'Neck-related Symptoms',
      'symptoms.neck.dizzinessHeadaches': 'Dizziness/headaches',
      'symptoms.neck.numbnessUpperLimbs': 'Numbness in upper limbs',
      'symptoms.neck.eyeStrainBlurredVision': 'Eye strain/blurred vision',
      'symptoms.neck.poorBalanceWalking': 'Poor balance while walking',
      'symptoms.neck.tinnitusHearingReduction': 'Tinnitus/hearing reduction',

      'symptoms.shoulder.title': 'Shoulder-related Symptoms',
      'symptoms.shoulder.limitedBackwardMovement': 'Limited backward movement',
      'symptoms.shoulder.painLiftingArms': 'Pain lifting arms',
      'symptoms.shoulder.tendernessStiffness': 'Tenderness or stiffness',

      'symptoms.spine.title': 'Spine/Posture Symptoms',
      'symptoms.spine.chestTightness': 'Chest tightness',
      'symptoms.spine.legLengthDifference': 'Leg length difference',
      'symptoms.spine.scoliosisAwareness': 'Scoliosis awareness',

      'symptoms.lumbar.title': 'Lumbar Symptoms',
      'symptoms.lumbar.radiatingLegPain': 'Radiating leg pain',
      'symptoms.lumbar.sciatica': 'Sciatica',
      'symptoms.lumbar.difficultyBendingStanding': 'Difficulty bending or standing long',
      'symptoms.lumbar.herniationSymptoms': 'Herniation symptoms',
      'symptoms.lumbar.backSpasms': 'Back spasms',

      'symptoms.knee.title': 'Knee Symptoms',
      'symptoms.knee.clickingSounds': 'Clicking sounds',
      'symptoms.knee.difficultyClimbingStairs': 'Difficulty climbing stairs',
      'symptoms.knee.swelling': 'Swelling',
      'symptoms.knee.weatherSensitivePain': 'Weather-sensitive pain',

      'symptoms.joints.title': 'Joint Symptoms',
      'symptoms.joints.stiffness': 'Stiffness',
      'symptoms.joints.inabilityStraightenLimbs': 'Inability to straighten limbs',
      'symptoms.joints.fearOfCold': 'Fear of cold in joints',

      'symptoms.other.title': 'Other Symptoms',
      'symptoms.other.fatigue': 'Fatigue',
      'symptoms.other.weakness': 'Weakness',
      'symptoms.other.sleepDisturbance': 'Sleep disturbance',

      // Lifestyle
      'lifestyle.habits.title': 'Lifestyle Habits',
      'lifestyle.smoking': 'Smoking',
      'lifestyle.alcohol': 'Alcohol intake',
      'lifestyle.workPosture.title': 'Work Posture',
      'lifestyle.workPosture.deskWork': 'Desk work',
      'lifestyle.workPosture.lifting': 'Lifting',
      'lifestyle.workPosture.repetitiveTasks': 'Repetitive tasks',
      'lifestyle.prolongedSitting': 'Prolonged sitting',
      'lifestyle.prolongedStanding': 'Prolonged standing',
      'lifestyle.stressLevel': 'Stress Level',
      'lifestyle.stressLevel.low': 'Low',
      'lifestyle.stressLevel.high': 'High',
      'lifestyle.sleepQuality': 'Sleep Quality',
      'lifestyle.sleepQuality.poor': 'Poor',
      'lifestyle.sleepQuality.fair': 'Fair',
      'lifestyle.sleepQuality.good': 'Good',
      'lifestyle.sleepQuality.excellent': 'Excellent',
      'lifestyle.activityLevel': 'Activity Level',
      'lifestyle.activityLevel.sedentary': 'Sedentary',
      'lifestyle.activityLevel.light': 'Light',
      'lifestyle.activityLevel.moderate': 'Moderate',
      'lifestyle.activityLevel.active': 'Active',

      // Women's Health
      'womens.title': "Women's Health",
      'womens.pregnancy': 'Currently pregnant',
      'womens.postpartum': 'Postpartum period',
      'womens.menstrualRegularity': 'Menstrual regularity',
      'womens.menstrualRegularity.regular': 'Regular',
      'womens.menstrualRegularity.irregular': 'Irregular',
      'womens.menstrualRegularity.none': 'No menstruation',
      'womens.menstrualPain': 'Menstrual pain',
      'womens.gynecologicalConditions': 'Gynecological conditions',
      'womens.gynecologicalConditions.placeholder': 'Please specify if any',

      // Medications & Allergies
      'medications.title': 'Medications & Allergies',
      'medications.current': 'Current medications',
      'medications.current.placeholder': 'Please list your current medications',
      'medications.supplements': 'Supplements/herbs',
      'medications.supplements.placeholder': 'Please list supplements or herbs you take',
      'allergies.medicine': 'Medicine allergies',
      'allergies.medicine.placeholder': 'Please list any medicine allergies',
      'allergies.food': 'Food allergies',
      'allergies.food.placeholder': 'Please list any food allergies',
      'allergies.environmental': 'Environmental allergies',
      'allergies.environmental.placeholder': 'e.g., pollen, dust mites',

      // Treatment Preferences
      'treatment.title': 'Treatment Preferences',
      'treatment.expectedOutcomes': 'Expected treatment outcomes',
      'treatment.expectedOutcomes.placeholder': 'Please describe your expected outcomes',
      'treatment.preferredTherapies': 'Preferred therapy types',
      'treatment.therapy.massage': 'Massage',
      'treatment.therapy.acupuncture': 'Acupuncture',
      'treatment.therapy.cupping': 'Cupping',
      'treatment.therapy.manualTherapy': 'Manual therapy',
      'treatment.therapy.exerciseRehab': 'Exercise rehab',
      'treatment.therapy.physicalTherapy': 'Physical therapy',
      'treatment.therapy.heatTherapy': 'Heat therapy',
      'treatment.therapy.electroTherapy': 'Electrotherapy',
      'treatment.refusedTreatments': 'Treatments you refuse or fear',
      'treatment.refusedTreatments.placeholder': 'Please specify if any',

      // Emergency Contact
      'field.emergency.name': 'Emergency Contact Name',
      'field.emergency.phone': 'Emergency Contact Phone',
      'field.emergency.relationship': 'Relationship',

      // Referral
      'field.referralSource': 'How did you hear about us',
      'field.referralSource.walk_in': 'Self-visit',
      'field.referralSource.referral': 'Friend Referral',
      'field.referralSource.online': 'Online Search',
      'field.referralSource.advertisement': 'Advertisement',
      'field.referralSource.social_media': 'Social Media',
      'field.referralSource.other': 'Other',
      'field.referredBy': 'Referrer Name',
      'field.referredByPhone': 'Referrer Phone Number',

      // Consent
      'consent.terms': 'Terms of Service',
      'consent.terms.text': 'I agree to the Terms of Service of Ming Yin Professional Health Center.',
      'consent.privacy': 'Privacy Policy',
      'consent.privacy.text': 'I consent to the collection and use of my personal data in accordance with the Privacy Policy.',
      'consent.health': 'Health Disclaimer',
      'consent.health.text': 'I confirm that I am in suitable health condition to receive wellness therapy services and will inform staff of any health issues.',
      'consent.marketing': 'Marketing (Optional)',
      'consent.marketing.text': 'I agree to receive promotional information and offers from Ming Yin Professional Health Center.',

      // Signature
      'signature.instruction': 'Please sign below to confirm the above information',
      'signature.clear': 'Clear',
      'signature.required': 'Please sign first',
      'signature.skipForStaff': 'Staff enrolling on behalf, skip signing for now',
      'signature.skipInfo': 'Member can sign later at the center. Staff will collect signature in CMS.',

      // Buttons
      'button.next': 'Next',
      'button.back': 'Back',
      'button.submit': 'Submit',
      'button.skip': 'Skip this section',
      'button.startOver': 'Start Over',
      'button.changeLanguage': 'Language',
      'button.closeWindow': 'Close Window',

      // Validation
      'validation.required': 'This field is required',
      'validation.email': 'Please enter a valid email address',
      'validation.phone': 'Please enter a valid phone number',
      'validation.hkIdFormat': 'Invalid format (e.g., A1234)',

      // Success
      'success.title': 'Registration Complete!',
      'success.message': 'Thank you for registering.',
      'success.memberId': 'Your Member ID',
      'success.passToStaff': 'Please return this device to staff',
      'success.passToStaffSubtext': 'Our staff will complete your registration',

      // Errors
      'error.title': 'An error occurred',
      'error.tryAgain': 'Please try again',
      'error.duplicatePhone': 'A member with this phone number already exists',
      'error.duplicateEmail': 'A member with this email already exists',
      'error.invalidEmail': 'Please provide a valid email address',
      'error.sessionExpired': 'Session expired. Please ask staff for a new enrollment link.',
      'error.serverError': 'Server error. Please try again later.',
      'error.networkError': 'Unable to connect. Please check your connection.',

      // Duplicate member dialog
      'duplicate.title': 'Member Already Exists',
      'duplicate.message': 'A member with this phone number is already registered.',
      'duplicate.viewInfo': 'View Member Info',
      'duplicate.changePhone': 'Use Different Phone',
      'duplicate.memberInfo': 'Existing Member Information',
      'duplicate.contactStaff': 'Please contact staff for assistance with existing members.',
      'duplicate.name': 'Name',
      'duplicate.phone': 'Phone',
      'duplicate.email': 'Email',
      'duplicate.memberSince': 'Member Since',
      'duplicate.close': 'Close',

      // Accessibility
      'accessibility.fontSize': 'Font Size',
      'accessibility.fontSize.normal': 'Normal',
      'accessibility.fontSize.large': 'Large',
      'accessibility.fontSize.xlarge': 'Extra Large',
      'accessibility.highContrast': 'High Contrast',
      'accessibility.highContrast.on': 'Enable High Contrast',
      'accessibility.highContrast.off': 'Disable High Contrast',

      // Auth/Session
      'auth.sessionBy': 'Session by',
      'auth.minutesRemaining': '{{count}} min remaining',
      'auth.sessionExpired': 'Session Expired',
      'auth.sessionExpiredMessage': 'Your enrollment session has expired. Please ask staff for a new enrollment link.',
      'auth.invalidSession': 'Invalid Session',
      'auth.invalidSessionMessage': 'The enrollment link is invalid or has expired. Please ask staff for a new enrollment link.',
      'auth.loading': 'Validating session...',
      'auth.sessionError': 'Session Error',
      'auth.accessDenied': 'Access Denied',
      'auth.noSession': 'No valid session found',
      'auth.instructionsError': 'Please close this window and open a new enrollment session from the CMS dashboard.',
      'auth.closeWindow': 'Close Window',
      'auth.expiringSoon': 'Session expiring soon!',
      'auth.verifying': 'Verifying session...',
      'auth.connectionError': 'Connection Error',
      'auth.serverUnreachable': 'Cannot Reach Server',
      'auth.serverUnreachableMessage': 'The enrollment system cannot reach the server. Your enrollment link may still be valid - please retry in a moment.',
      'auth.instructionsServerUnreachable': 'Please wait a moment, then tap Retry. If this keeps happening, notify IT support.',
      'auth.retry': 'Retry',
      'auth.unknownErrorMessage': 'An unexpected error occurred while validating the session.',
    }
  },
  'zh-CN': {
    translation: {
      // App
      'app.title': '名彦专业养生理疗中心',
      'app.subtitle': '会员登记',
      'app.welcome': '欢迎光临',

      // Steps
      'step.personal': '个人资料',
      'step.contact': '联络资料',
      'step.bodyMetrics': '身体数据',
      'step.bodyMetrics.description': '请填写您的身高和体重（选填）',
      'step.chiefComplaint': '主要诉求',
      'step.chiefComplaint.description': '请告诉我们您今天来访的主要原因',
      'step.healthConditions': '健康状况',
      'step.painAssessment': '疼痛评估',
      'step.symptomChecklist': '症状检查',
      'step.symptoms': '症状检查',
      'step.symptoms.description': '请选择您目前出现的症状（选填）',
      'step.lifestyle': '生活习惯及疗法偏好',
      'step.emergency': '紧急联络人',
      'step.emergency.description': '请提供紧急联络人资料（选填）',
      'step.review': '资料确认',
      'step.review.description': '请确认以下资料是否正确',
      'step.review.continueToConsent': '确认无误后，请点击「下一步」继续',
      'step.consent': '同意条款',
      'step.signature': '签名确认',
      'step.complete': '完成登记',

      // Common
      'common.yes': '是',
      'common.no': '否',
      'common.select': '请选择',
      'common.notProvided': '未填写',
      'common.pleaseSpecify': '请说明',

      // Personal Info
      'field.firstName': '名字',
      'field.lastName': '姓氏',
      'field.email': '电邮地址',
      'field.email.optional': '选填',
      'field.phone': '电话号码',
      'field.dateOfBirth': '出生日期',
      'field.gender': '性别',
      'field.gender.male': '男',
      'field.gender.female': '女',
      'field.gender.other': '其他',
      'field.hkId': '香港身份证（首5位）',
      'field.hkId.helper': '格式：A1234 或 AB123',
      'field.occupation': '职业',
      'field.year': '年',
      'field.month': '月',

      // Month names
      'month.1': '1月',
      'month.2': '2月',
      'month.3': '3月',
      'month.4': '4月',
      'month.5': '5月',
      'month.6': '6月',
      'month.7': '7月',
      'month.8': '8月',
      'month.9': '9月',
      'month.10': '10月',
      'month.11': '11月',
      'month.12': '12月',

      // Body Metrics
      'field.height': '身高',
      'field.weight': '体重',
      'unit.meters': '米',
      'unit.feet': '尺',
      'unit.kg': '公斤',
      'unit.lbs': '磅',

      // Chief Complaint
      'field.symptomOnset': '症状/疼痛开始时间',
      'field.chiefComplaint': '主要求诊原因',
      'field.chiefComplaint.placeholder': '请描述您今天来访的主要原因',
      'field.mainProblem': '最希望解决的问题',
      'field.mainProblem.placeholder': '请描述您最想解决的问题是什么',

      // Medical Conditions
      'conditions.title': '健康状况（如有请勾选）',
      'conditions.highBloodPressure': '高血压',
      'conditions.diabetes': '糖尿病',
      'conditions.heartDisease': '心脏病',
      'conditions.thyroidDisease': '甲状腺疾病',
      'conditions.liverGallbladderStomach': '肝/胆/胃问题',
      'conditions.cancerTumorSurgery': '癌症/肿瘤/手术史',
      'conditions.breastConditions': '乳房手术/疾病',
      'conditions.allergies': '过敏体质',
      'conditions.insomnia': '失眠',
      'conditions.obesity': '肥胖/高体脂',
      'conditions.thalassemia': '地中海贫血',
      'conditions.pregnancyPostpartumMenstrual': '怀孕/产后/经期问题',
      'conditions.anxietyEmotional': '焦虑/情绪问题',
      'conditions.kidneyProblems': '肾脏问题',
      'conditions.reproductivePelvic': '生殖/骨盆疾病',

      // Medical History
      'medicalHistory.title': '病史',
      'medicalHistory.surgery': '曾否接受手术',
      'medicalHistory.surgery.placeholder': '请说明手术类型及时间',
      'medicalHistory.injury': '曾否受伤',
      'medicalHistory.injury.placeholder': '请说明受伤情况',
      'medicalHistory.accident': '曾否发生意外',
      'medicalHistory.accident.placeholder': '请说明意外情况',
      'medicalHistory.implant': '体内是否有植入物/异物',
      'medicalHistory.implant.placeholder': '请说明植入物类型',

      // Imaging History
      'imaging.title': '检查及治疗记录',
      'imaging.xray': 'X光',
      'imaging.ctScan': 'CT扫描',
      'imaging.mri': 'MRI',
      'imaging.electrotherapy': '电疗',
      'imaging.magneticTherapy': '磁疗',
      'imaging.previousTreatment': '曾接受的治疗',
      'imaging.previousTreatment.placeholder': '请描述您曾接受过的治疗',
      'imaging.effectiveness': '治疗效果',
      'imaging.effectiveness.placeholder': '请描述之前治疗的效果如何',

      // Pain Location
      'pain.location.title': '疼痛部位',
      'pain.location.neck': '颈部',
      'pain.location.shoulder': '肩膀',
      'pain.location.upperBack': '上背',
      'pain.location.lowerBack': '下背',
      'pain.location.lumbar': '腰部',
      'pain.location.hips': '髋部',
      'pain.location.knees': '膝盖',
      'pain.location.armsElbowsWrists': '手臂/肘/腕',
      'pain.location.legsSciatica': '腿部/坐骨神经',
      'pain.location.other': '其他',
      'pain.location.otherDetails': '其他部位说明',
      'pain.location.otherDetails.placeholder': '请说明其他疼痛部位',
      'pain.side.left': '左',
      'pain.side.right': '右',
      'pain.side.both': '双侧',

      // Pain Characteristics
      'pain.characteristics.title': '疼痛特征',
      'pain.type.title': '疼痛类型',
      'pain.type.dull': '钝痛',
      'pain.type.sharp': '刺痛',
      'pain.type.radiating': '放射痛',
      'pain.type.numbness': '麻木',
      'pain.type.tingling': '刺麻',
      'pain.trigger.title': '疼痛诱因',
      'pain.trigger.movement': '活动时',
      'pain.trigger.lifting': '提重物时',
      'pain.trigger.prolongedStanding': '久站时',
      'pain.severity': '疼痛程度',
      'pain.severity.none': '无痛',
      'pain.severity.worst': '极痛',
      'pain.frequency.title': '疼痛频率',
      'pain.frequency.constant': '持续',
      'pain.frequency.intermittent': '间歇',

      // Symptoms by body area
      'symptoms.neck.title': '颈部相关症状',
      'symptoms.neck.dizzinessHeadaches': '头晕/头痛',
      'symptoms.neck.numbnessUpperLimbs': '上肢麻木',
      'symptoms.neck.eyeStrainBlurredVision': '眼睛疲劳/视力模糊',
      'symptoms.neck.poorBalanceWalking': '步行平衡差',
      'symptoms.neck.tinnitusHearingReduction': '耳鸣/听力下降',

      'symptoms.shoulder.title': '肩膀相关症状',
      'symptoms.shoulder.limitedBackwardMovement': '向后活动受限',
      'symptoms.shoulder.painLiftingArms': '举手疼痛',
      'symptoms.shoulder.tendernessStiffness': '压痛/僵硬',

      'symptoms.spine.title': '脊椎/姿势相关症状',
      'symptoms.spine.chestTightness': '胸闷',
      'symptoms.spine.legLengthDifference': '双腿长度不一',
      'symptoms.spine.scoliosisAwareness': '脊柱侧弯意识',

      'symptoms.lumbar.title': '腰部相关症状',
      'symptoms.lumbar.radiatingLegPain': '腿部放射痛',
      'symptoms.lumbar.sciatica': '坐骨神经痛',
      'symptoms.lumbar.difficultyBendingStanding': '弯腰/久站困难',
      'symptoms.lumbar.herniationSymptoms': '椎间盘突出症状',
      'symptoms.lumbar.backSpasms': '背部痉挛',

      'symptoms.knee.title': '膝盖相关症状',
      'symptoms.knee.clickingSounds': '响声',
      'symptoms.knee.difficultyClimbingStairs': '上下楼梯困难',
      'symptoms.knee.swelling': '肿胀',
      'symptoms.knee.weatherSensitivePain': '天气敏感痛',

      'symptoms.joints.title': '关节相关症状',
      'symptoms.joints.stiffness': '僵硬',
      'symptoms.joints.inabilityStraightenLimbs': '无法伸直四肢',
      'symptoms.joints.fearOfCold': '怕冷',

      'symptoms.other.title': '其他症状',
      'symptoms.other.fatigue': '疲劳',
      'symptoms.other.weakness': '无力',
      'symptoms.other.sleepDisturbance': '睡眠障碍',

      // Lifestyle
      'lifestyle.habits.title': '生活习惯',
      'lifestyle.smoking': '吸烟',
      'lifestyle.alcohol': '饮酒',
      'lifestyle.workPosture.title': '工作姿势',
      'lifestyle.workPosture.deskWork': '久坐工作',
      'lifestyle.workPosture.lifting': '搬重物',
      'lifestyle.workPosture.repetitiveTasks': '重复性工作',
      'lifestyle.prolongedSitting': '长时间坐着',
      'lifestyle.prolongedStanding': '长时间站立',
      'lifestyle.stressLevel': '压力程度',
      'lifestyle.stressLevel.low': '低',
      'lifestyle.stressLevel.high': '高',
      'lifestyle.sleepQuality': '睡眠质量',
      'lifestyle.sleepQuality.poor': '差',
      'lifestyle.sleepQuality.fair': '一般',
      'lifestyle.sleepQuality.good': '好',
      'lifestyle.sleepQuality.excellent': '很好',
      'lifestyle.activityLevel': '活动量',
      'lifestyle.activityLevel.sedentary': '久坐不动',
      'lifestyle.activityLevel.light': '轻度',
      'lifestyle.activityLevel.moderate': '中度',
      'lifestyle.activityLevel.active': '活跃',

      // Women's Health
      'womens.title': '女性健康',
      'womens.pregnancy': '目前怀孕',
      'womens.postpartum': '产后期间',
      'womens.menstrualRegularity': '月经规律',
      'womens.menstrualRegularity.regular': '规律',
      'womens.menstrualRegularity.irregular': '不规律',
      'womens.menstrualRegularity.none': '无月经',
      'womens.menstrualPain': '经期疼痛',
      'womens.gynecologicalConditions': '妇科疾病',
      'womens.gynecologicalConditions.placeholder': '如有妇科疾病请说明',

      // Medications & Allergies
      'medications.title': '药物及过敏',
      'medications.current': '目前服用药物',
      'medications.current.placeholder': '请列出您目前服用的药物',
      'medications.supplements': '保健品/中药',
      'medications.supplements.placeholder': '请列出您正在服用的保健品或中药',
      'allergies.medicine': '药物过敏',
      'allergies.medicine.placeholder': '请列出您对哪些药物过敏',
      'allergies.food': '食物过敏',
      'allergies.food.placeholder': '请列出您对哪些食物过敏',
      'allergies.environmental': '环境过敏',
      'allergies.environmental.placeholder': '如花粉、尘螨等',

      // Treatment Preferences
      'treatment.title': '疗法偏好',
      'treatment.expectedOutcomes': '期望治疗效果',
      'treatment.expectedOutcomes.placeholder': '请描述您期望的治疗效果',
      'treatment.preferredTherapies': '偏好的疗法',
      'treatment.therapy.massage': '按摩',
      'treatment.therapy.acupuncture': '针灸',
      'treatment.therapy.cupping': '拔罐',
      'treatment.therapy.manualTherapy': '手法治疗',
      'treatment.therapy.exerciseRehab': '运动复健',
      'treatment.therapy.physicalTherapy': '物理治疗',
      'treatment.therapy.heatTherapy': '热疗',
      'treatment.therapy.electroTherapy': '电疗',
      'treatment.refusedTreatments': '拒绝或害怕的疗法',
      'treatment.refusedTreatments.placeholder': '如有请说明',

      // Emergency Contact
      'field.emergency.name': '紧急联络人姓名',
      'field.emergency.phone': '紧急联络人电话',
      'field.emergency.relationship': '关系',

      // Referral
      'field.referralSource': '如何得知我们',
      'field.referralSource.walk_in': '自行到访',
      'field.referralSource.referral': '朋友推荐',
      'field.referralSource.online': '网上搜索',
      'field.referralSource.advertisement': '广告',
      'field.referralSource.social_media': '社交媒体',
      'field.referralSource.other': '其他',
      'field.referredBy': '推荐人姓名',
      'field.referredByPhone': '推荐人电话号码',

      // Consent
      'consent.terms': '服务条款',
      'consent.terms.text': '本人同意接受名彦专业养生理疗中心的服务条款。',
      'consent.privacy': '隐私政策',
      'consent.privacy.text': '本人同意名彦专业养生理疗中心按照隐私政策收集及使用本人的个人资料。',
      'consent.health': '健康免责声明',
      'consent.health.text': '本人确认身体状况适合接受养生理疗服务，如有任何健康问题会主动告知职员。',
      'consent.marketing': '市场推广（选填）',
      'consent.marketing.text': '本人同意接收名彦专业养生理疗中心的推广资讯及优惠通知。',

      // Signature
      'signature.instruction': '请在下方签名确认以上资料',
      'signature.clear': '清除',
      'signature.required': '请先签名',
      'signature.skipForStaff': '职员代为登记，稍后补签',
      'signature.skipInfo': '会员稍后可在中心补签署。职员将在 CMS 系统中收集签名。',

      // Buttons
      'button.next': '下一步',
      'button.back': '返回',
      'button.submit': '提交',
      'button.skip': '跳过此步骤',
      'button.startOver': '重新开始',
      'button.changeLanguage': '语言',
      'button.closeWindow': '关闭窗口',

      // Validation
      'validation.required': '此栏位为必填',
      'validation.email': '请输入有效的电邮地址',
      'validation.phone': '请输入有效的电话号码',
      'validation.hkIdFormat': '格式不正确（例：A1234）',

      // Success
      'success.title': '登记成功！',
      'success.message': '感谢您的登记。',
      'success.memberId': '您的会员编号',
      'success.passToStaff': '请将设备交还给职员',
      'success.passToStaffSubtext': '职员将为您完成登记程序',

      // Errors
      'error.title': '发生错误',
      'error.tryAgain': '请重试',
      'error.duplicatePhone': '此电话号码已被注册',
      'error.duplicateEmail': '此邮箱地址已被注册',
      'error.invalidEmail': '请提供有效的邮箱地址',
      'error.sessionExpired': '会话已过期。请向工作人员索取新的登记链接。',
      'error.serverError': '服务器错误。请稍后再试。',
      'error.networkError': '无法连接。请检查您的网络连接。',

      // Duplicate member dialog
      'duplicate.title': '会员已存在',
      'duplicate.message': '此电话号码已有会员注册。',
      'duplicate.viewInfo': '查看会员资料',
      'duplicate.changePhone': '使用其他电话',
      'duplicate.memberInfo': '现有会员资料',
      'duplicate.contactStaff': '如需处理现有会员事宜，请联系工作人员协助。',
      'duplicate.name': '姓名',
      'duplicate.phone': '电话',
      'duplicate.email': '邮箱',
      'duplicate.memberSince': '注册日期',
      'duplicate.close': '关闭',

      // Accessibility
      'accessibility.fontSize': '字体大小',
      'accessibility.fontSize.normal': '正常',
      'accessibility.fontSize.large': '大',
      'accessibility.fontSize.xlarge': '特大',
      'accessibility.highContrast': '高对比',
      'accessibility.highContrast.on': '开启高对比',
      'accessibility.highContrast.off': '关闭高对比',

      // Auth/Session
      'auth.sessionBy': '登入者',
      'auth.minutesRemaining': '剩余 {{count}} 分钟',
      'auth.sessionExpired': '会话已过期',
      'auth.sessionExpiredMessage': '您的登记会话已过期。请向职员索取新的登记链接。',
      'auth.invalidSession': '无效的会话',
      'auth.invalidSessionMessage': '登记链接无效或已过期。请向职员索取新的登记链接。',
      'auth.loading': '正在验证会话...',
      'auth.sessionError': '会话错误',
      'auth.accessDenied': '拒绝访问',
      'auth.noSession': '未找到有效的会话',
      'auth.instructionsError': '请关闭此窗口并从 CMS 控制台开启新的登记会话。',
      'auth.closeWindow': '关闭窗口',
      'auth.expiringSoon': '会话即将过期！',
      'auth.verifying': '正在验证会话...',
      'auth.connectionError': '连接错误',
      'auth.serverUnreachable': '无法连接服务器',
      'auth.serverUnreachableMessage': '暂时无法连接登记系统服务器。您的登记链接可能仍然有效，请稍后重试。',
      'auth.instructionsServerUnreachable': '请稍候片刻，然后按“重试”。如问题持续，请通知信息部同事。',
      'auth.retry': '重试',
      'auth.unknownErrorMessage': '验证会话时发生未预期的错误。',
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'zh-TW',
    lng: 'zh-TW', // Default to Traditional Chinese
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
